'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colType = exports.ROW_TYPES = undefined;

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _isEqual2 = require('lodash/isEqual');

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _find = require('lodash/find');

var _find2 = _interopRequireDefault(_find);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _checkbox = require('../../components/checkbox');

var _checkbox2 = _interopRequireDefault(_checkbox);

var _styledText = require('../../components/styled-text');

var _styledText2 = _interopRequireDefault(_styledText);

var _hoverLink = require('../../components/hover-link');

var _hoverLink2 = _interopRequireDefault(_hoverLink);

var _scrollArea = require('../scroll-area');

var _scrollArea2 = _interopRequireDefault(_scrollArea);

var _ChevronDownIcon = require('../../icons/ChevronDownIcon');

var _ChevronUpIcon = require('../../icons/ChevronUpIcon');

var _MinusThickIcon = require('../../icons/MinusThickIcon');

var _proptypes = require('../util/proptypes');

var _palette = require('../../palette');

require('./table.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var defaultComparator = function defaultComparator(a, b) {
  if (a === b) {
    return 0;
  }

  if (a > b) {
    return 1;
  }

  return -1;
};

var ROW_TYPES = exports.ROW_TYPES = {
  light: 'light',
  striped: 'striped'
};

var sortData = function sortData(data, key, isAscending) {
  var comparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultComparator;
  var isCaseSensitive = arguments[4];

  var compareTo = function compareTo(a, b) {
    var valueA = a[key];
    var valueB = b[key];

    if (typeof a[key] === 'string' && !isCaseSensitive) {
      valueA = valueA.toLowerCase();
      valueB = valueB.toLowerCase();
    }

    var ascending = !isAscending ? -1 : 1;
    var result = comparator(valueA, valueB);
    return result * ascending;
  };

  var sortedData = [].concat(_toConsumableArray(data)).sort(compareTo);
  return sortedData;
};

var colType = exports.colType = _propTypes2.default.shape({
  comparator: _propTypes2.default.func,
  dataKey: _propTypes2.default.string.isRequired,
  entireRow: _propTypes2.default.bool,
  // pass the rowData to the renderer instead of dataKey.
  headerTitle: _propTypes2.default.string.isRequired,
  isSortable: _propTypes2.default.bool,
  onRowClick: _propTypes2.default.func,
  onRowHover: _propTypes2.default.func,
  renderer: _propTypes2.default.func,
  columnWidth: _propTypes2.default.number
});

var PROPTYPES = {
  currentStepRow: _propTypes2.default.number,
  data: _propTypes2.default.array.isRequired,
  defaultSortKey: _propTypes2.default.string,
  displayHeader: _propTypes2.default.bool,
  header: _propTypes2.default.arrayOf(colType),
  isAscending: _propTypes2.default.bool,
  isGroupsData: _propTypes2.default.bool,
  isRowClicked: _proptypes.STYLE_PROP,
  isEverythingSelected: _propTypes2.default.bool,
  // Used to indicate if the select all toggle in the selection status row should be checked or not
  isSelectable: _propTypes2.default.bool,
  // If true, render an extra column of checkmarks
  onCollapseAllClick: _propTypes2.default.func,
  onExpandCollapseClick: _propTypes2.default.func,
  onHeaderPress: _propTypes2.default.func,
  // A method that fires when the header is pressed, typically used for sorting
  onSelectionToggle: _propTypes2.default.func,
  // A method that fires when a selectable row is selected or deselected
  onSelectAllToggle: _propTypes2.default.func,
  // A method that fires when the select all checkbox is selected or deselected
  rowStyle: _proptypes.STYLE_PROP,
  selectedIndexes: _propTypes2.default.array,
  // A list of indexes of rows that are selected, used when the table data doesn't include selection status
  selectionStatusRow: _propTypes2.default.shape({
    // If exists, contains options to renders an extra row above header indicating selection stats
    labelString: _propTypes2.default.string,
    // The current status string that shows the selected number of rows
    secondaryCountString: _propTypes2.default.string,
    //  The count the user needs to keep track of (e.g. "1 out of 5")
    secondaryLabelString: _propTypes2.default.string,
    // The right side label that displays selected out of total rows
    selectedRowsTotal: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    // The sum of all selected rows kept by the consuming component- influences appearance of select all checkbox
    secondaryItems: _propTypes2.default.array // An array of optional JSX items to render in the status bar

  }),
  type: _propTypes2.default.oneOf([ROW_TYPES.striped, ROW_TYPES.light]),
  useVisibleHoverState: _propTypes2.default.bool
};
var STYLE_BASE = 'zk-table-';

var Bold = function Bold(props) {
  return _react2.default.createElement(_styledText2.default, _extends({
    className: STYLE_BASE + 'bold'
  }, props));
};

var Table = function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this.updateDataAfterSortingCallback = function () {
      var _this$props = _this.props,
          updateDataAfterSorting = _this$props.updateDataAfterSorting,
          data = _this$props.data;
      var _this$state = _this.state,
          sortedData = _this$state.sortedData,
          isAscending = _this$state.isAscending,
          sortKey = _this$state.sortKey;

      if (updateDataAfterSorting && !(0, _isEqual3.default)(data, sortedData)) {
        updateDataAfterSorting(sortedData, isAscending, sortKey);
      }
    };

    _this.groupsDataHandler = function () {
      var _this$props2 = _this.props,
          _this$props2$enableGr = _this$props2.enableGroupExpandCollapse,
          enableGroupExpandCollapse = _this$props2$enableGr === undefined ? false : _this$props2$enableGr,
          _this$props2$isGroups = _this$props2.isGroupsData,
          isGroupsData = _this$props2$isGroups === undefined ? false : _this$props2$isGroups;

      if (enableGroupExpandCollapse && isGroupsData) {
        _this.enableCollapseAll();
      }
    };

    _this.enableCollapseAll = function () {
      var _this$props$isGroupsC = _this.props.isGroupsCollapsedDefault,
          isGroupsCollapsedDefault = _this$props$isGroupsC === undefined ? false : _this$props$isGroupsC;
      var _this$state2 = _this.state,
          sortedData = _this$state2.sortedData,
          useCollapseAll = _this$state2.useCollapseAll;
      var useGroups = sortedData.filter(function (row) {
        if (row.groupId && row.useGroup) {
          return true;
        }

        return false;
      });
      var collapseGroupsIdList = useGroups.map(function (row) {
        return row.groupId;
      });

      if (!(0, _isEqual3.default)(collapseGroupsIdList, _this.state.collapseGroupsIdList)) {
        if (isGroupsCollapsedDefault) {
          var isCollapseAll = isGroupsCollapsedDefault;
          var collapseGroupsList = collapseGroupsIdList.slice();

          _this.setState({
            collapseGroupsIdList: collapseGroupsIdList,
            collapseGroupsList: collapseGroupsList,
            isCollapseAll: isCollapseAll
          });
        } else {
          _this.setState({
            collapseGroupsIdList: collapseGroupsIdList
          });
        }
      }

      if (!!_this.props.collapseGroupsList && !(0, _isEqual3.default)(_this.props.collapseGroupsList, _this.state.collapseGroupsList)) {
        var _collapseGroupsList = _this.props.collapseGroupsList;

        _this.setState({
          collapseGroupsList: _collapseGroupsList
        });
      }

      if (!useCollapseAll && useGroups.length > 0) {
        _this.setState({
          useCollapseAll: true
        });
      }
    };

    _this.defaultCollapseAll = function () {
      var collapseGroupsIdList = _this.state.collapseGroupsIdList;
      var isCollapseAll = !_this.state.isCollapseAll;
      var collapseGroupsList = [];

      if (isCollapseAll) {
        collapseGroupsList = collapseGroupsIdList.slice();
      }

      _this.setState({
        collapseGroupsList: collapseGroupsList,
        isCollapseAll: isCollapseAll
      });
    };

    _this.onCollapseAllClick = function () {
      if (!!_this.props.onCollapseAllClick) {
        var isCollapseAll = _this.state.isCollapseAll;

        _this.props.onCollapseAllClick({
          isCollapseAll: isCollapseAll
        });
      } else {
        _this.defaultCollapseAll();
      }
    };

    _this.defaultExpandCollapse = function (rowData) {
      var _rowData$groupId = rowData.groupId,
          groupId = _rowData$groupId === undefined ? '' : _rowData$groupId;
      var collapseGroupsList = [];

      if (_this.isGroupIdInCollapseGroupsList(groupId)) {
        collapseGroupsList = _this.state.collapseGroupsList;
        var index = collapseGroupsList.indexOf(groupId);
        collapseGroupsList.splice(index, 1);
      } else {
        var prevCollapseGroupsList = _this.state.collapseGroupsList || [];
        collapseGroupsList = [].concat(_toConsumableArray(prevCollapseGroupsList), [groupId]);
      }

      if (collapseGroupsList.length > 0) {
        _this.setState({
          collapseGroupsList: collapseGroupsList,
          isCollapseAll: true
        });
      } else {
        _this.setState({
          collapseGroupsList: collapseGroupsList,
          isCollapseAll: false
        });
      }
    };

    _this.onExpandCollapseClick = function (rowData) {
      if (!!_this.props.onExpandCollapseClick) {
        var collapseGroupsList = _this.state.collapseGroupsList;

        _this.props.onExpandCollapseClick({
          collapseGroupsList: collapseGroupsList,
          rowData: rowData
        });
      } else {
        _this.defaultExpandCollapse(rowData);
      }
    };

    _this.isGroupIdInCollapseGroupsList = function (groupId) {
      var collapseGroupsList = _this.state.collapseGroupsList;

      if (collapseGroupsList && groupId && collapseGroupsList.indexOf(groupId) > -1) {
        return true;
      }

      return false;
    };

    _this.renderExpandCollapseArrow = function (rowData) {
      var _rowData$groupId2 = rowData.groupId,
          groupId = _rowData$groupId2 === undefined ? '' : _rowData$groupId2;
      var useCollapseArrow = false;

      if (_this.isGroupIdInCollapseGroupsList(groupId)) {
        useCollapseArrow = true;
      }

      var arrowSizes = {
        height: 20,
        width: 20
      };
      return _react2.default.createElement('div', {
        className: STYLE_BASE + 'expandCollapse-arrow',
        onClick: function onClick() {
          return _this.onExpandCollapseClick(rowData);
        }
      }, useCollapseArrow ? _react2.default.createElement(_ChevronUpIcon.ChevronUpIcon, arrowSizes) : _react2.default.createElement(_ChevronDownIcon.ChevronDownIcon, arrowSizes));
    };

    _this.onOuterPress = function (e) {
      _this.setState({
        isClicked: false
      });
    };

    _this.onInnerPress = function (e) {
      _this.setState({
        isClicked: true
      });
    };

    _this.onHeaderPress = function (key, comparator) {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          onHeaderPress = _this$props3.onHeaderPress;
      var _this$state3 = _this.state,
          isAscending = _this$state3.isAscending,
          sortKey = _this$state3.sortKey;
      var newIsAscending = sortKey === key ? !isAscending : true;

      if (onHeaderPress) {
        onHeaderPress(key, newIsAscending); // needs isAscending and sortKey to switch the arrows

        _this.setState({
          isAscending: newIsAscending,
          sortKey: key
        });
      } else {
        // Execute default sorting if a there's no custom header press method
        _this.setState({
          sortKey: key,
          isAscending: newIsAscending,
          sortedData: sortData(data, key, newIsAscending, comparator)
        }, _this.updateDataAfterSortingCallback);
      }
    };

    _this.state = _this.getState(props);
    _this.tableRef = _react2.default.createRef();
    return _this;
  }

  _createClass(Table, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.groupsDataHandler();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var propsArray = ['data', 'isAscending', 'sortKey'];
      var oldProps = (0, _pick3.default)(prevProps, propsArray);
      var newProps = (0, _pick3.default)(this.props, propsArray);

      if (!(0, _isEqual3.default)(oldProps, newProps)) {
        this.setState(this.getState(this.props), this.updateDataAfterSortingCallback);
      }

      this.groupsDataHandler();
    }
  }, {
    key: 'getState',
    value: function getState(props) {
      var data = props.data,
          header = props.header,
          _props$isAscending = props.isAscending,
          isAscending = _props$isAscending === undefined ? true : _props$isAscending,
          _props$isCaseSensitiv = props.isCaseSensitive,
          isCaseSensitive = _props$isCaseSensitiv === undefined ? false : _props$isCaseSensitiv,
          onHeaderPress = props.onHeaderPress;
      var sortKey = props.sortKey || this.state && this.state.sortKey || props.defaultSortKey;
      var sortedData = data;

      if (sortKey) {
        var currentHeader = (0, _find2.default)(header, ['dataKey', sortKey]) || {};

        if (!onHeaderPress) {
          sortedData = sortData(data, sortKey, isAscending, currentHeader.comparator, isCaseSensitive);
        }
      }

      var collapseGroupsList = [];
      var collapseGroupsIdList = [];
      var isCollapseAll = false;
      var useCollapseAll = false;
      return {
        collapseGroupsList: collapseGroupsList,
        collapseGroupsIdList: collapseGroupsIdList,
        isCollapseAll: isCollapseAll,
        useCollapseAll: useCollapseAll,
        sortedData: sortedData,
        hoveredKey: null,
        isAscending: isAscending,
        sortKey: sortKey
      };
    }
  }, {
    key: 'getData',
    value: function getData(rowData) {
      var _props$header = this.props.header,
          header = _props$header === undefined ? null : _props$header;
      return header || this.getRowKeys(rowData);
    }
  }, {
    key: 'getRenderer',
    value: function getRenderer(rowData, currentColumn) {
      var dataKey = currentColumn.dataKey;
      return rowData[dataKey] && rowData[dataKey].renderer || rowData.renderer || currentColumn.renderer || null;
    }
  }, {
    key: 'getRowKeys',
    value: function getRowKeys(row) {
      return Object.keys(row).filter(function (value) {
        return value !== 'renderer';
      }).map(function (value) {
        return {
          dataKey: value
        };
      });
    }
  }, {
    key: 'getCellData',
    value: function getCellData(currentColumn) {
      return currentColumn.dataKey || currentColumn;
    }
  }, {
    key: 'renderSelectionStatusRow',
    value: function renderSelectionStatusRow() {
      var _classNames;

      var _props = this.props,
          _props$disableSelecti = _props.disableSelectionStatusRowCheckbox,
          disableSelectionStatusRowCheckbox = _props$disableSelecti === undefined ? false : _props$disableSelecti,
          isEverythingSelected = _props.isEverythingSelected,
          selectionStatusRow = _props.selectionStatusRow,
          _props$onSelectAllTog = _props.onSelectAllToggle,
          onSelectAllToggle = _props$onSelectAllTog === undefined ? _noop2.default : _props$onSelectAllTog,
          panelPosition = _props.panelPosition;
      var _state = this.state,
          isCollapseAll = _state.isCollapseAll,
          useCollapseAll = _state.useCollapseAll;
      var isTableTopOffScreen = this.tableRef && this.tableRef.current && panelPosition >= this.tableRef.current.offsetTop;
      var isTableBottomOffScreen = this.tableRef && this.tableRef.current && panelPosition >= this.tableRef.current.offsetTop + this.tableRef.current.offsetHeight;
      return _react2.default.createElement('div', {
        className: STYLE_BASE + 'selectionStatusPlaceholder'
      }, _react2.default.createElement('div', {
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, STYLE_BASE + 'selectionStatusRow', true), _defineProperty(_classNames, STYLE_BASE + 'selectionStatusRow-fixed', isTableTopOffScreen && !isTableBottomOffScreen), _classNames))
      }, _react2.default.createElement('div', {
        className: STYLE_BASE + 'selectionStatusCell'
      }, !disableSelectionStatusRowCheckbox && _react2.default.createElement(_checkbox2.default, {
        checked: isEverythingSelected || !!selectionStatusRow.selectedRowsTotal,
        onChange: onSelectAllToggle,
        testid: 'SELECT_ALL_ROWS_CHECKBOX',
        customCheckmark: !isEverythingSelected ? _react2.default.createElement(_MinusThickIcon.MinusThickIcon, {
          width: 12,
          height: 12,
          color: _palette.white
        }) : null
      }), _react2.default.createElement(_styledText2.default, {
        className: STYLE_BASE + 'selectionStatusText'
      }, selectionStatusRow.selectedRowsTotal, ' ', selectionStatusRow.labelString)), !!selectionStatusRow.selectedRowsTotal && _react2.default.createElement('div', {
        className: STYLE_BASE + 'multiselectActionsContainer'
      }, selectionStatusRow.secondaryItems), _react2.default.createElement(_styledText2.default, {
        className: STYLE_BASE + 'quotaStatus'
      }, _react2.default.createElement(Bold, null, selectionStatusRow.secondaryCountString + ' '), selectionStatusRow.secondaryLabelString), useCollapseAll && _react2.default.createElement(_hoverLink2.default, {
        className: STYLE_BASE + 'collapseToggle',
        onPress: this.onCollapseAllClick
      }, isCollapseAll ? 'Expand All' : 'Collapse All')));
    } // TODO: (PT) make sure toe onMouseDown style still works, added isRowClicked: active to SCSS file
    // getRowStyleOnPressed(rowId) {
    //   const { type, onRowClick, isRowClicked } = this.props;
    //   const { hoveredRow } = this.state;
    //   let style = [onRowClick ? styles.clickableTableRow : styles.tableRow];
    //   switch (type) {
    //     case ROW_TYPES.light:
    //       style.push(styles.lightRows);
    //       break;
    //     case ROW_TYPES.striped:
    //     default:
    //       style.push(rowId % 2 === 1 ? styles.oddRow : styles.evenRow);
    //       break;
    //   }
    //   if (onRowClick && hoveredRow === rowId) {
    //     style.push(styles.isRowClicked);
    //   }
    //   return style;
    // }

  }, {
    key: 'onRowHover',
    value: function onRowHover(hovered, index) {
      var onRowHover = this.props.onRowHover;
      var hoveredRow = this.state.hoveredRow;

      if (Number.isFinite(hoveredRow) && !hovered || hoveredRow !== index) {
        this.setState({
          hoveredRow: hovered ? index : null
        });
        onRowHover && onRowHover(hovered, index);
      }
    }
  }, {
    key: 'renderColumnGroup',
    value: function renderColumnGroup(header) {
      var _props2 = this.props,
          isSelectable = _props2.isSelectable,
          columnClassName = _props2.columnClassName,
          columnGroup = _props2.columnGroup;
      if (columnGroup) return columnGroup;
      return _react2.default.createElement('colgroup', null, isSelectable && _react2.default.createElement('col', {
        className: STYLE_BASE + 'selectionCol'
      }), header.map(function (data, index) {
        var _classNames2;

        return _react2.default.createElement('col', {
          className: (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, STYLE_BASE + 'column', true), _defineProperty(_classNames2, columnClassName, !!columnClassName), _classNames2)),
          key: index
        });
      }));
    }
  }, {
    key: 'renderHeader',
    value: function renderHeader(header) {
      var _this2 = this;

      var _props3 = this.props,
          headerClassName = _props3.headerClassName,
          isSelectable = _props3.isSelectable,
          sortableHeaderTabTestId = _props3.sortableHeaderTabTestId;
      return _react2.default.createElement('tr', null, isSelectable && _react2.default.createElement('th', {
        className: STYLE_BASE + 'selectionCell'
      }), header.map(function (headerData, index) {
        var isSortable = headerData.isSortable,
            dataKey = headerData.dataKey,
            comparator = headerData.comparator,
            headerTitle = headerData.headerTitle;
        if (!headerTitle) return null;

        var titleToShow = _react2.default.createElement(_styledText2.default, {
          secondary: true,
          className: STYLE_BASE + 'header-text'
        }, headerTitle.toUpperCase());

        return _react2.default.createElement('th', {
          key: index,
          className: (0, _classnames2.default)(_defineProperty({}, headerClassName, !!headerClassName))
        }, isSortable ? _react2.default.createElement('div', {
          'data-testid': sortableHeaderTabTestId,
          className: STYLE_BASE + 'sortableHeaderCell',
          onClick: function onClick() {
            return _this2.onHeaderPress(dataKey, comparator);
          }
        }, titleToShow, _this2.renderSortArrow(dataKey)) : titleToShow);
      }));
    }
  }, {
    key: 'renderSortArrow',
    value: function renderSortArrow(dataKey) {
      var _classNames4;

      var _state2 = this.state,
          isAscending = _state2.isAscending,
          sortKey = _state2.sortKey;
      var arrowSizes = {
        height: 15,
        width: 15
      };
      var useUpArrow = isAscending;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)((_classNames4 = {}, _defineProperty(_classNames4, STYLE_BASE + 'header-arrow', true), _defineProperty(_classNames4, STYLE_BASE + 'header-arrow-active-sort-column', dataKey === sortKey), _classNames4))
      }, useUpArrow ? _react2.default.createElement(_ChevronUpIcon.ChevronUpIcon, arrowSizes) : _react2.default.createElement(_ChevronDownIcon.ChevronDownIcon, arrowSizes));
    }
  }, {
    key: 'renderRows',
    value: function renderRows(data) {
      var _this3 = this;

      var _props4 = this.props,
          _props4$enableGroupEx = _props4.enableGroupExpandCollapse,
          enableGroupExpandCollapse = _props4$enableGroupEx === undefined ? false : _props4$enableGroupEx,
          _props4$isGroupsData = _props4.isGroupsData,
          isGroupsData = _props4$isGroupsData === undefined ? false : _props4$isGroupsData,
          isSelectable = _props4.isSelectable,
          onRowClick = _props4.onRowClick,
          onSelectionToggle = _props4.onSelectionToggle,
          rowClassName = _props4.rowClassName,
          selectedIndexes = _props4.selectedIndexes,
          type = _props4.type,
          _props4$useVirtualLis = _props4.useVirtualList,
          useVirtualList = _props4$useVirtualLis === undefined ? false : _props4$useVirtualLis,
          useVisibleHoverState = _props4.useVisibleHoverState;
      var useLightTable = type === ROW_TYPES.light;
      return data.map(function (rowData, rowId) {
        var _classNames5, _classNames6;

        var rowDataToShow = _this3.getData(rowData);

        var _rowData$groupId3 = rowData.groupId,
            groupId = _rowData$groupId3 === undefined ? '' : _rowData$groupId3,
            top = rowData.top,
            _rowData$useGroup = rowData.useGroup,
            useGroup = _rowData$useGroup === undefined ? false : _rowData$useGroup;
        var _rowData$disableRowCh = rowData.disableRowCheckbox,
            disableRowCheckbox = _rowData$disableRowCh === undefined ? false : _rowData$disableRowCh,
            _rowData$useGroupRow = rowData.useGroupRow,
            useGroupRow = _rowData$useGroupRow === undefined ? false : _rowData$useGroupRow,
            _rowData$useGroupRowL = rowData.useGroupRowLast,
            useGroupRowLast = _rowData$useGroupRowL === undefined ? false : _rowData$useGroupRowL,
            _rowData$useGroupSpac = rowData.useGroupSpacer,
            useGroupSpacer = _rowData$useGroupSpac === undefined ? false : _rowData$useGroupSpac;

        var useGroupCollapse = isGroupsData && _this3.isGroupIdInCollapseGroupsList(groupId);

        var isRowSelected = rowData.isSelected || selectedIndexes && selectedIndexes.includes(rowId);
        var position = 'absolute';
        var inlineStyle = useVirtualList && !!top ? {
          position: position,
          top: top
        } : null;

        if (useGroupSpacer) {
          disableRowCheckbox = true;
        }

        return _react2.default.createElement('tr', {
          key: rowId,
          className: (0, _classnames2.default)((_classNames5 = {}, _defineProperty(_classNames5, rowClassName, !!rowClassName), _defineProperty(_classNames5, STYLE_BASE + 'light-rows', useLightTable), _defineProperty(_classNames5, STYLE_BASE + 'group', isGroupsData && useGroup), _defineProperty(_classNames5, STYLE_BASE + 'group-row', isGroupsData && useGroupRow), _defineProperty(_classNames5, STYLE_BASE + 'group-row last', isGroupsData && useGroupRowLast), _defineProperty(_classNames5, STYLE_BASE + 'group-row spacer', isGroupsData && useGroupSpacer), _defineProperty(_classNames5, 'group-collapse', useGroupCollapse), _defineProperty(_classNames5, STYLE_BASE + 'hover', useVisibleHoverState), _defineProperty(_classNames5, STYLE_BASE + 'selectedRow', isRowSelected), _classNames5)),
          onMouseEnter: function onMouseEnter() {
            return _this3.onRowHover(true, rowId);
          },
          onMouseLeave: function onMouseLeave() {
            return _this3.onRowHover(false, rowId);
          },
          onClick: function onClick(event) {
            return onRowClick(rowData, event);
          },
          style: inlineStyle,
          'data-testid': 'TABLE_ROW_' + rowId
        }, isSelectable && _react2.default.createElement('td', {
          className: STYLE_BASE + 'selectionCell',
          key: rowId + 'checkBox'
        }, !disableRowCheckbox && _react2.default.createElement(_checkbox2.default, {
          checked: isRowSelected,
          className: (0, _classnames2.default)((_classNames6 = {}, _defineProperty(_classNames6, STYLE_BASE + 'cellCheckbox', true), _defineProperty(_classNames6, STYLE_BASE + 'groupRowCellCheckbox', useGroupRow || useGroupRowLast), _classNames6)),
          onChange: onSelectionToggle && function (value, event) {
            return onSelectionToggle(rowId, rowData, value, event);
          }
        })), rowDataToShow.map(function (currentColumn, index) {
          var _currentColumn$entire = currentColumn.entireRow,
              entireRow = _currentColumn$entire === undefined ? false : _currentColumn$entire;

          var renderer = _this3.getRenderer(rowData, currentColumn); // NOTE(JG): If we are passing an entireRow we have to make sure we
          //  have a custom render function, if not fallback to dataKey


          var currentData = null;

          if (entireRow && renderer) {
            currentData = rowData;
          } else {
            currentData = rowData[_this3.getCellData(currentColumn)];
            currentData = typeof currentData !== 'undefined' && currentData !== null ? currentData : '';
            currentData = currentData.data || currentData;
          }

          var child = renderer ? renderer(currentData, rowId) : currentData;
          var isInsertExpandCollapseArrow = enableGroupExpandCollapse && isGroupsData && useGroup && rowDataToShow.length > 1 && index === rowDataToShow.length - 1;

          var cell = _react2.default.createElement('td', {
            key: _this3.getCellData(currentColumn)
          }, child);

          if (isInsertExpandCollapseArrow) {
            cell = _react2.default.createElement('td', {
              key: '' + _this3.getCellData(currentColumn)
            }, _this3.renderExpandCollapseArrow(rowData));
          } else if (typeof child === 'string' || typeof child === 'number') {
            cell = _react2.default.createElement('td', {
              key: _this3.getCellData(currentColumn)
            }, _react2.default.createElement(_styledText2.default, {
              numberOfLines: 1,
              className: STYLE_BASE + 'cellText'
            }, child));
          }

          return cell;
        }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _classNames7;

      var _props5 = this.props,
          header = _props5.header,
          isSelectable = _props5.isSelectable,
          tableClassName = _props5.tableClassName,
          height = _props5.height,
          selectionStatusRow = _props5.selectionStatusRow,
          _props5$useVirtualLis = _props5.useVirtualList,
          useVirtualList = _props5$useVirtualLis === undefined ? false : _props5$useVirtualLis,
          noScrollArea = _props5.noScrollArea;
      var sortedData = this.state.sortedData;
      var inlineStyle = useVirtualList && !!height ? {
        height: height
      } : null;
      var Wrapper = noScrollArea ? 'div' : _scrollArea2.default;
      return _react2.default.createElement(Wrapper, {
        className: STYLE_BASE + 'tablaWrapperScroll'
      }, _react2.default.createElement('div', {
        ref: this.tableRef
      }, selectionStatusRow && this.renderSelectionStatusRow(), _react2.default.createElement('table', {
        className: (0, _classnames2.default)((_classNames7 = {
          'zk-table': true
        }, _defineProperty(_classNames7, STYLE_BASE + 'selectable', isSelectable), _defineProperty(_classNames7, tableClassName, !!tableClassName), _classNames7)),
        style: inlineStyle
      }, this.renderColumnGroup(header), _react2.default.createElement('thead', null, this.renderHeader(header)), _react2.default.createElement('tbody', null, this.renderRows(sortedData)))));
    }
  }]);

  return Table;
}(_react.Component);

Table.propTypes = PROPTYPES;
Table.defaultProps = {
  displayHeader: true,
  isAscending: true,
  onRowClick: function onRowClick() {},
  type: ROW_TYPES.striped,
  useVisibleHoverState: true
};
exports.default = Table;